import { Col, Container, FlagsIcons, Row } from "../../components";
import { useContextHook } from "../../Context/ContextOPen";
import { content } from "../../lang/useLang";
import logo from "../../assets/images/1.png";
const AboutUs = () => {
  const { swiperIndex, direction } = useContextHook();

  return (
    <>
      <div
        className="min-h-screen py-5 bg-gradient-to-br from-slate-900 via-purple-900 to-violet-900  relative overflow-hidden"
        style={{ direction }}
      >
        <br />
        {/* خلفية متحركة - تظهر فقط في الشريحة النشطة */}
        {swiperIndex === 1 && (
          <>
            {/* أشكال هندسية متحركة */}
            <div className="absolute inset-0 overflow-hidden opacity-20">
              <div className="absolute top-1/4 -left-20 w-80 h-80 bg-purple-500/20 rounded-full blur-3xl animate-orbital-slow"></div>
              <div className="absolute bottom-1/4 -right-20 w-96 h-96 bg-violet-500/20 rounded-full blur-3xl animate-orbital-reverse"></div>
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-pink-500/10 rounded-full blur-2xl animate-pulse-soft"></div>
            </div>

            {/* خطوط متقاطعة متحركة */}
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-0 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-purple-400 to-transparent animate-scan-horizontal"></div>
              <div
                className="absolute top-1/3 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-violet-400 to-transparent animate-scan-horizontal"
                style={{ animationDelay: "1s" }}
              ></div>
              <div
                className="absolute top-2/3 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-pink-400 to-transparent animate-scan-horizontal"
                style={{ animationDelay: "2s" }}
              ></div>
            </div>

            {/* جسيمات نجوم */}
            <div className="absolute inset-0 opacity-40">
              {[...Array(12)].map((_, i) => (
                <div
                  key={i}
                  className="absolute w-3 h-3 bg-white rounded-full animate-twinkle-star"
                  style={{
                    left: `${Math.random() * 100}%`,
                    top: `${Math.random() * 100}%`,
                    animationDelay: `${Math.random() * 4}s`,
                    animationDuration: `${2 + Math.random() * 3}s`,
                  }}
                ></div>
              ))}
            </div>
          </>
        )}

        <Container className="relative z-10 flex items-center">
          <Row className=" ">
            {/* الصورة مع تصميم جديد */}
            <Col
              md={5}
              className="flex justify-center items-center relative group"
            >
              {/* إطار دائري متحرك */}
              <div className="absolute w-80 h-80 border-2 border-purple-400/30 rounded-full animate-rotate-slow"></div>
              <div className="absolute w-72 h-72 border-2 border-violet-400/40 rounded-full animate-rotate-reverse"></div>

              {/* البطاقة الرئيسية للصورة */}
              <div>
                <div className="relative overflow-hidden rounded-3xl">
                  <img
                    src={logo}
                    alt="Company Logo"
                    className="w-full  object-cover transition-transform duration-1000 group-hover:scale-110"
                  />
                </div>
              </div>
            </Col>

            {/* المحتوى النصي */}
            <Col
              md={7}
              className={`relative transform transition-all duration-1000 ${
                swiperIndex === 1
                  ? "opacity-100 translate-x-0"
                  : "opacity-0 translate-x-10"
              }`}
              style={{
                transitionDelay: "600ms",
              }}
            >
              {/* خلفية نصية زخرفية */}
              <div className="absolute -inset-6 bg-gradient-to-r from-purple-500/5 to-violet-500/5 rounded-4xl blur-2xl opacity-0 group-hover:opacity-50 transition-opacity duration-1000"></div>

              <div className="relative space-y-8 p-2">
                {/* العنوان الرئيسي */}
                <div className="space-y-4">
                  <h1 className="text-6xl max-md:text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-purple-300 via-violet-400 to-pink-300 drop-shadow-2xl">
                    {content.about_us}
                  </h1>

                  <div className="text-3xl max-sm:text-xl font-bold text-white/90 logo">
                    {content.company}
                  </div>

                  {/* خط زخرفي */}
                  <div className="w-32 h-1.5 bg-gradient-to-r from-purple-400 to-violet-500 rounded-full shadow-lg shadow-purple-500/30"></div>
                </div>

                {/* الأعلام مع تصميم جديد */}
                <div
                  className="transform transition-all duration-1000 delay-800"
                  style={{
                    opacity: swiperIndex === 1 ? 1 : 0,
                    transform:
                      swiperIndex === 1
                        ? "translateY(0) scale(1)"
                        : "translateY(20px) scale(0.9)",
                  }}
                >
                  <FlagsIcons index={1} />
                </div>

                {/* النص مع أنيميشن متتالية */}
                <div className="space-y-6">
                  <div
                    className="p-6 bg-white/5 rounded-2xl border border-white/10 backdrop-blur-sm hover:bg-white/10 transition-all duration-500 hover:-translate-y-1 hover:shadow-xl"
                    style={{
                      opacity: swiperIndex === 1 ? 1 : 0,
                      transform:
                        swiperIndex === 1
                          ? "translateY(0)"
                          : "translateY(20px)",
                      transitionDelay: "1000ms",
                      transition: "all 0.8s cubic-bezier(0.34, 1.56, 0.64, 1)",
                    }}
                  >
                    <p className="text-lg leading-8 text-gray-100 font-light">
                      {content.des_about_us_one}
                    </p>
                  </div>

                  <div
                    className="p-6 bg-white/5 rounded-2xl border border-white/10 backdrop-blur-sm hover:bg-white/10 transition-all duration-500 hover:-translate-y-1 hover:shadow-xl"
                    style={{
                      opacity: swiperIndex === 1 ? 1 : 0,
                      transform:
                        swiperIndex === 1
                          ? "translateY(0)"
                          : "translateY(20px)",
                      transitionDelay: "1200ms",
                      transition: "all 0.8s cubic-bezier(0.34, 1.56, 0.64, 1)",
                    }}
                  >
                    <p className="text-lg leading-8 text-gray-100 font-light">
                      {content.des_about_us_tow}
                    </p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>

        {/* الأنيميشن المخصصة */}
        {swiperIndex === 1 && (
          <style jsx>{`
            @keyframes orbital-slow {
              0%,
              100% {
                transform: translate(0, 0) rotate(0deg) scale(1);
              }
              25% {
                transform: translate(40px, -20px) rotate(90deg) scale(1.1);
              }
              50% {
                transform: translate(0, -40px) rotate(180deg) scale(1.2);
              }
              75% {
                transform: translate(-40px, -20px) rotate(270deg) scale(1.1);
              }
            }
            @keyframes orbital-reverse {
              0%,
              100% {
                transform: translate(0, 0) rotate(0deg) scale(1);
              }
              25% {
                transform: translate(-30px, 15px) rotate(-90deg) scale(1.05);
              }
              50% {
                transform: translate(0, 30px) rotate(-180deg) scale(1.1);
              }
              75% {
                transform: translate(30px, 15px) rotate(-270deg) scale(1.05);
              }
            }
            @keyframes pulse-soft {
              0%,
              100% {
                opacity: 0.1;
                transform: scale(1);
              }
              50% {
                opacity: 0.3;
                transform: scale(1.05);
              }
            }
            @keyframes scan-horizontal {
              0% {
                transform: translateX(-100%);
              }
              100% {
                transform: translateX(100%);
              }
            }
            @keyframes twinkle-star {
              0%,
              100% {
                opacity: 0.3;
                transform: scale(1);
              }
              50% {
                opacity: 1;
                transform: scale(1.5);
                box-shadow: 0 0 20px #fff;
              }
            }
            @keyframes rotate-slow {
              from {
                transform: rotate(0deg);
              }
              to {
                transform: rotate(360deg);
              }
            }
            @keyframes rotate-reverse {
              from {
                transform: rotate(360deg);
              }
              to {
                transform: rotate(0deg);
              }
            }
            @keyframes shine {
              0% {
                transform: translateX(-100%) skewX(-12deg);
              }
              100% {
                transform: translateX(200%) skewX(-12deg);
              }
            }
            .animate-orbital-slow {
              animation: orbital-slow 25s ease-in-out infinite;
            }
            .animate-orbital-reverse {
              animation: orbital-reverse 30s ease-in-out infinite;
            }
            .animate-pulse-soft {
              animation: pulse-soft 6s ease-in-out infinite;
            }
            .animate-scan-horizontal {
              animation: scan-horizontal 4s linear infinite;
            }
            .animate-twinkle-star {
              animation: twinkle-star 3s ease-in-out infinite;
            }
            .animate-rotate-slow {
              animation: rotate-slow 20s linear infinite;
            }
            .animate-rotate-reverse {
              animation: rotate-reverse 25s linear infinite;
            }
            .animate-shine {
              animation: shine 3s ease-in-out;
            }
          `}</style>
        )}
      </div>
    </>
  );
};

export default AboutUs;
